// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__CUDC2","label":"styles_label__KDCO8","input":"styles_input__oDv-R","btn_submit":"styles_btn_submit__7Zweq"};